import { render, staticRenderFns } from "./ManageFarm.vue?vue&type=template&id=9a10ff22&"
import script from "./ManageFarm.vue?vue&type=script&lang=js&"
export * from "./ManageFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports